'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleValidationMessage = exports.handleSetStateMessage = exports.handleSetBotAgent = exports.handleQueryBotAgentMessage = exports.handleAuthCheckMessage = exports.handleApiMessage = exports.handleSearchMessage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _responseUtils = require('./response-utils.js');

var _responseUtils2 = _interopRequireDefault(_responseUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleSearchMessage = exports.handleSearchMessage = function handleSearchMessage(data) {
  var msgType = data.msgType,
      response = data.response,
      responseMsgs = data.responseMsgs,
      sessionId = data.sessionId;

  if (msgType === 'search') {
    var searchMsg = response.queryResult.search ? response.queryResult.search.response : null;
    responseMsgs.push({
      intent: response.queryResult.intent,
      msg: searchMsg,
      msgType: msgType,
      search: response.queryResult.search,
      sessionId: sessionId
    });
  }
};

var handleApiMessage = exports.handleApiMessage = function handleApiMessage(data) {
  var msgType = data.msgType,
      msg = data.msg,
      response = data.response,
      responseMsgs = data.responseMsgs,
      sessionId = data.sessionId;

  if (msgType === 'api') {
    responseMsgs.push({ msg: msg, msgType: msgType, api: response.queryResult.api, intent: response.queryResult.intent, sessionId: sessionId });
  }
};

var handleAuthCheckMessage = exports.handleAuthCheckMessage = function handleAuthCheckMessage(data) {
  var msgType = data.msgType,
      msg = data.msg,
      response = data.response,
      helpBot = data.helpBot;

  if (msgType === 'authCheck') {
    var api = response.queryResult.api;
    if (!api) {
      return;
    }

    var isAuthenticated = api.type === 'shopper' && !api.error && api.result && api.result.shopperId;

    var authEvent = isAuthenticated ? msg.payload.fields.authenticatedEvent.stringValue : msg.payload.fields.unauthenticatedEvent.stringValue;
    helpBot.triggerEvent(authEvent);
  }
};

var handleQueryBotAgentMessage = exports.handleQueryBotAgentMessage = function handleQueryBotAgentMessage(data) {
  var msgType = data.msgType,
      msg = data.msg,
      helpBot = data.helpBot,
      userMessageText = data.userMessageText;

  if (msgType === 'queryBotAgent') {
    var chatbotsApiBaseUrl = helpBot.state.chatbotsApiBaseUrl;

    var queryApiUrl = chatbotsApiBaseUrl + '/queryIntent?sid=' + helpBot.props.sessionId + '&q=' + userMessageText;
    _responseUtils2.default.getQueryPayloadsNextEvent(msg, queryApiUrl, function (eventName) {
      helpBot.triggerEvent(eventName);
    });
  }
};

var handleSetBotAgent = exports.handleSetBotAgent = function handleSetBotAgent(data) {
  var msgType = data.msgType,
      msg = data.msg,
      helpBot = data.helpBot;

  if (msgType === 'setBotAgent') {
    helpBot.setBotProjectId(msg.payload.fields.botProjectId.stringValue);

    var _responseUtils$getBot = _responseUtils2.default.getBotSwitcherNextUtterance(msg, helpBot),
        nextEvent = _responseUtils$getBot.nextEvent,
        nextUtterance = _responseUtils$getBot.nextUtterance;

    if (nextEvent) {
      helpBot.triggerEvent(nextEvent);
    } else if (nextUtterance) {
      helpBot.sendUserMessageText(nextUtterance);
    }
  }
};

var getFieldJson = function getFieldJson(payload) {
  var fields = payload && payload.structValue && payload.structValue.fields;
  if (fields) {
    return Object.keys(fields).reduce(function (accumulator, key) {
      accumulator[key] = fields[key].stringValue || '';
      return accumulator;
    }, {});
  }
};

var handleSetStateMessage = exports.handleSetStateMessage = function handleSetStateMessage(data) {
  var msgType = data.msgType,
      msg = data.msg,
      helpBot = data.helpBot,
      response = data.response;

  if (msgType === 'setState') {
    if (msg.payload.fields.valueType && msg.payload.fields.valueType.stringValue === 'string') {
      var states = msg.payload.fields.state;
      var stateJson = getFieldJson(states);
      if (stateJson) {
        helpBot.props.appDialogFlowSet(stateJson);
      }
    }
    if (msg.payload.fields.valueType.stringValue === 'waitTimes') {
      helpBot.props.appDialogFlowSet(response.queryResult.waitTimes);
    }
  }
};

var handleValidationMessage = exports.handleValidationMessage = function handleValidationMessage(data) {
  var msgType = data.msgType,
      msg = data.msg,
      helpBot = data.helpBot;

  if (msgType === 'validator' && msg && msg.payload && msg.payload.fields) {
    var validation = msg.payload.fields.validation;
    var validationJson = getFieldJson(validation);
    if (validationJson) {
      helpBot.props.appDialogFlowSet({ validation: _extends({}, validationJson) });
    }
  }
};